import React, { useContext } from "react";
import { Context } from "./LanguageWrapper";

type Props = {
  className?: string;
};

const LanguageSwitcher = ({ className = "" }: Props) => {
  const { locale, selectLanguage } = useContext(Context);

  return (
    <div
      className={`language-switcher ${className}`.trim()}
      role="group"
      aria-label="Language"
    >
      <select
        className="form-select form-select-sm language-switcher__select"
        value={locale === "alb" ? "alb" : "en"}
        onChange={(e) => selectLanguage(e.target.value)}
        aria-label="Select language"
        style={{
          minWidth: "6.5rem",
          width: "auto",
          cursor: "pointer",
          fontSize: "0.8125rem",
        }}
      >
        <option value="en">English</option>
        <option value="alb">Shqip</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
